// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_RemoveItemInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/remove_item/{item_id}
 *
 * Removes an item from an order. No body required — item_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Orders_RemoveItemInput {}

registerContract('Orders_RemoveItemInput', {})
